/**
 * 一定時間経過でポップアップ起動
 */
import ReactDOM from 'react-dom';
import Axios from 'axios';
import moment from 'moment/moment';
import '@/shared/global';
import Laroute from '@/shared/laroute';
import Popup from '@/shared/components/popup';
import Cookie, { COOKIE_KEY_USER, COOKIE_ADMIN_TYPE } from '@/shared/cookie';
import { LSKEY_POPUP } from '@/shared/constants/localstorage';

const timeout = 1000; // タイムアウト監視感覚(ms)
let countDown = 7000; // ポップアップが表示されるまでの時間(ms)

/**
 * タイマー処理
 */
const timer = (el) => {
    // 別のモーダルが開いていたらカウントダウンなどはスルー
    if (!window.St.modal) {
        countDown -= timeout;

        if (countDown < 0) {
            api(el.dataset.page_type).then(({ data }) => {
                if (!data || isNotDisplay(data.popup_id)) {
                    return;
                }

                breakTime(data.popup_id);

                ReactDOM.render(
                    <Popup
                        id="popup"
                        tracking={Cookie.get(COOKIE_KEY_USER)}
                        adminType={Cookie.get(COOKIE_ADMIN_TYPE)}
                        requestIp={el.dataset.request_ip}
                        {...data}
                    />,
                    el,
                );
            });

            return;
        }
    }

    setTimeout(timer, timeout, el);
};

/**
 * APIアクセス
 *
 * @param {string} page_type
 * @returns Promise
 */
const api = (page_type) => {
    const endpoint = Laroute.route('user.api.popup', { pageType: page_type }) + '/';

    return Axios.get(endpoint);
};

/**
 * 再登場待ちさせる時刻を設定
 * @param {int} id
 */
const breakTime = (id) => {
    localStorage.setItem(LSKEY_POPUP(id), moment().add(1, 'days').toJSON());
};

/**
 * 一定期間再表示停止の判定
 *
 * @param {int} id
 * @returns {boolean}
 */
const isNotDisplay = (id) => {
    const expiry = moment(localStorage.getItem(LSKEY_POPUP(id))); // 有効期限
    const now = moment(moment().toJSON()); // JSON形式に合わせた現在時刻の設定

    return expiry.isAfter(now); // 有効期限が現在時刻より未来の場合は表示しない
};

window.addEventListener('load', () => {
    const el = document.getElementById('popup');

    el && timer(el);
});
